"use client";
import { userInfoApi } from "@/api/login";
import SignInModal, { SignInModalProps } from "@/components/ModalPopup/SignInModal";
import dialogManager from "@/dialog/manager";
import { useSignStore } from "@/stores/useSignStore";
import { getToken } from "@/utils/Cookies";
import dayjs from "dayjs";
import { FC, useEffect, useRef, useState } from "react";

const SignInSection: FC = () => {
    const SignInRef = useRef<SignInModalProps>(null);
    const [activityId, setActivityId] = useState<number | null>(null);
    const keyName = "SignInSection";
    const { getSignData, signData } = useSignStore((state) => {
        return {
            getSignData: state.getSignData,
            signData: state.signData,
        };
    });
    const getMaxSignId = (obj: any) => {
        if (!obj) return null;
        const signArr: number[] = [];
        Object.keys(obj).map((key) => {
            if (obj[key] === 9) {
                signArr.push(Number(key));
            }
        });
        return signArr.length > 0 ? Math.max(...signArr) : null;
    };
    const getUserInfo = async () => {
        const res: any = await userInfoApi();
        if (res.code === 200 && res.data?.activity) {
            const activity_id = getMaxSignId(res.data?.activity);
            if (activity_id) {
                setActivityId(activity_id);
                await getSignData({ activity_id: activity_id });
            }
        }
    };
    const checkIsShowed = () => {
        const showTime = localStorage.getItem("sign");
        if (showTime) {
            const nextDay = dayjs(Number(showTime)).add(1, "day").format("YYYY-MM-DD");
            if (dayjs(nextDay).isAfter(dayjs())) {
                return true;
            }
        }
        return false;
    };
    useEffect(() => {
        if (getToken()) getUserInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dialogManager.registerDialog({
            key: keyName,
            show() {
                if (getToken()) {
                    SignInRef?.current?.onOpen();
                    return;
                }
                // if (!checkIsShowed() && getToken()) {
                //     localStorage.setItem("sign", Date.now().toString());
                //     SignInRef?.current?.onOpen();
                //     return;
                // }
                return "close";
            },
        });
    }, []);

    const destoryComponent = () => {
        dialogManager.hideDialog(keyName); // 隐藏对话框
    };

    if (!activityId) {
        return null;
    }
    return (
        <>
            <SignInModal ref={SignInRef} onDestory={destoryComponent}></SignInModal>
        </>
    );
};

export default SignInSection;
